import React from "react";
import { ThreeDots } from "react-loader-spinner";

interface LoadingProps {
  customColor: any;
}
const LoadingComponent = ({ customColor }: LoadingProps) => {
  const defaultColor = "#e53e3e";
  return (
    <div>
      <ThreeDots
        visible={true}
        height="80"
        width="80"
        color={customColor ? customColor : defaultColor}
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

export default LoadingComponent;
